// Shared skeleton primitives for first-load placeholders. Built off the
// ad-hoc "bg-gray-200 rounded animate-pulse" blocks already used for the
// Vehicle/Property unattached-docs placeholder (Vehicle/index.tsx:690-696,
// Property/index.tsx:690-698) so new skeleton compositions look consistent
// with that prior art. Per-screen layouts (dashboard grid tiles, document
// rows, reminder cards, search rows) live next to their screens and compose
// these three shapes.
export type SkeletonElementProps = {
  className?: string;
  'data-cy'?: string;
};

const BASE_CLASSNAME = 'bg-gray-200 animate-pulse';

// General rectangular block: icon badges, image blocks, chips. Defaults to a
// small corner radius; pass className (e.g. "rounded-lg", "rounded-2xl") to
// match the shape being placeholder-ed.
const SkeletonRect = ({ className = '', 'data-cy': dataCy }: SkeletonElementProps) => (
  <div className={`${BASE_CLASSNAME} rounded ${className}`} data-cy={dataCy} aria-hidden="true" />
);

// Circular avatar / icon badge placeholder.
const SkeletonCircle = ({ className = '', 'data-cy': dataCy }: SkeletonElementProps) => (
  <div className={`${BASE_CLASSNAME} rounded-full ${className}`} data-cy={dataCy} aria-hidden="true" />
);

// Text-line placeholder (heading, subheading, label).
const SkeletonLine = ({ className = '', 'data-cy': dataCy }: SkeletonElementProps) => (
  <div className={`${BASE_CLASSNAME} rounded ${className}`} data-cy={dataCy} aria-hidden="true" />
);

export const Skeleton = {
  Rect: SkeletonRect,
  Circle: SkeletonCircle,
  Line: SkeletonLine,
};

export default Skeleton;
